import { Language } from "typings";
import { IContextualMenuItem } from "office-ui-fabric-react";

export const languageMenu = (languages: Language[], onLanguageChange: (language: string) => void ) 
    : IContextualMenuItem[] =>
{
    const onLanguageClick = (ev?: React.MouseEvent<HTMLElement>, item?: IContextualMenuItem) =>
    {
        if (item)
        {
            onLanguageChange(item.key);
        }
    };
    return languages.map(lang =>
        ({
            key: lang.name,
            name: lang.englishName,
            onClick: onLanguageClick,
        }));
};


// WEBPACK FOOTER //
// ./src/util/language.ts